import _ from "lodash";
import cache from "../plugins/cache";
import axios from "../plugins/axios";

export const getTipos = async (params = { forceReload: false }) => {
    const { forceReload } = params;
    const url = 'tipos';
    const cachedResult = await cache.get(url, 'POST', {});
    if (cachedResult && !forceReload) {
        return _.get(cachedResult, 'response', cachedResult);
    }
    return axios.post(url, {}).then(async (res) => {
        let idsTiposOrdernado = [6, 1, 7, 3, 2, 9, 4, 8, 5]
        let tipos = [6, 1, 7, 3, 2, 9, 4, 8, 5]
        for (let t of _.get(res, 'data.data')) {
            let index = idsTiposOrdernado.findIndex(tid => t.id === tid)
            tipos[index] = t
        }
        await cache.set(url, tipos, { method: 'POST', body: {} });
        return tipos;
    })
}

export const getAlimentosBasicosCqbal = async (params = { forceReload: false }) => {
    const { forceReload } = params;
    const url = 'relatorio/alimentosBrCorte';
    const cachedResult = await cache.get(url, 'POST', {});
    if (cachedResult && !forceReload) {
        return _.get(cachedResult, 'response', cachedResult);
    }
    return axios.post(url, {}).then(async (res) => {
        const data = _.get(res, 'data.data');
        await cache.set(url, data, { method: 'POST', body: {} });
        return data;
    })
}
export const getAlimentosEmpresa = async (params = { forceReload: false, idempresa: null, areadaempresa: false }) => {
    const { forceReload, idempresa, areadaempresa } = params;
    const url = (idempresa === null) ? 'alimentos/getAlimentosPatrocinados' : 'alimentos/getAlimentosEmpresa';
    const paramsReq = (areadaempresa) ? { id_empresa: idempresa, area_da_empresa: areadaempresa } : { id_empresa: idempresa };
    const cachedResult = await cache.get(url, 'POST', paramsReq);
    if (cachedResult && !forceReload) {
        return _.get(cachedResult, 'response', cachedResult);
    }
    return axios.post(url, paramsReq).then(response => {
        const data = _.get(response, 'data.data');
        cache.set(url, data, { method: 'POST', body: paramsReq });
        return data;
    })
}
export const getAlimentosUsuario = async (params = { forceReload: false, idUser: null }) => {
    const { forceReload, idUser } = params;
    const url = "alimentos/getAlimentosUsuario";
    const paramsReq = { id_pessoa: idUser };
    const cachedResult = await cache.get(url, 'POST', paramsReq);
    if (cachedResult && !forceReload) {
        return _.get(cachedResult, 'response', cachedResult);
    }
    return axios.post(url, paramsReq).then(response => {
        const data = _.get(response, 'data.data');
        cache.set(url, data, { method: 'POST', body: paramsReq });
        return data;
    })
}
export const podeUsarCacheAlimentosUsr = async () => {
    const url = 'brcorte/lastupdatedAlimentosUsuario';
    let res = null;
    let last = null;
    const currentLast = localStorage.getItem('lastupdatedAlimentosUsuario');
    try {
        res = await axios.post(url);
        last = _.get(res, 'data.data.last_updated', null);
        if (last === null) return true;
        if (parseInt(currentLast) === parseInt(last)) return true;
        localStorage.setItem('lastupdatedAlimentosUsuario', last);
        return false;
    } catch (e) {
        console.log('podeUsarCacheAlimentosUsr => ', { e });
        return true;
    }
}
export const limparDadosIDBAlimentos = async () => {
    try {
        localStorage.removeItem('lastupdatedAlimentosUsuario')
        return await cache.deleteByUrlAndMethod('alimentos/getListaAlimentos', 'POST')
    } catch (error) {
        return false
    }
}
export const getAlimentos = async (params = { forceReload: false, idDieta: null }) => {
    const { forceReload, idDieta } = params;
    const tipos = await getTipos();
    const alimentosBasicos = await getAlimentosBasicosCqbal();
    const url = 'alimentos/getListaAlimentos';
    const paramsReq = { apenasUSREMP: true, id_dieta: idDieta };
    const cachedResult = await cache.get(url, 'POST', paramsReq);
    const podeUsarCacheUsr = await podeUsarCacheAlimentosUsr()
    const podeUsarCache = cachedResult && !forceReload && podeUsarCacheUsr
    let alimentosResponse = {};
    if (podeUsarCache) {
        alimentosResponse['data'] = {
            'data': _.get(cachedResult, 'response', cachedResult)
        }
    } else {
        alimentosResponse = await axios.post(url, paramsReq);
        cache.set(url, _.get(alimentosResponse, 'data.data'), { method: 'POST', body: paramsReq });
    }
    const alimentosEmp = _.get(alimentosResponse, 'data.data.emp', []);
    const alimentosUsr = _.get(alimentosResponse, 'data.data.usr', []);
    return {
        tipos,
        alimentosBasicos,
        alimentosEmp,
        alimentosUsr
    }
}